import ContentReveal from '../content-reveal'

export default class BlockVideo extends ContentReveal {
	static title = 'block-video'
}
